import React, { FunctionComponent } from "react";
import { Outlet } from "react-router-dom";

/**
 * UsersOutlet is a React component that serves as a placeholder for nested routes.
 * It uses React Router's Outlet component to render child routes within the users section.
 * 
 * @component
 * @returns {JSX.Element} A component that renders nested routes
 */

interface UsersOutletProps {}


const UsersOutlet: FunctionComponent<UsersOutletProps> = () => {
  return <Outlet />;
};

export default UsersOutlet;
